var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"main",class:((_vm.$vuetify.breakpoint.xs) ? 'textsmall' : 'text'),attrs:{"fluid":""}},[_vm._v(" PME ")])}
var staticRenderFns = []

export { render, staticRenderFns }